import styled from "styled-components";

export const ResetModalStyle=styled.div`
.alert-modal {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  justify-content: center;
  align-items: center;
  z-index:3;
}

.alert-modal.open {
  display:flex;
}

.modal-content {
  background: white;
  font-family: 'Inter var', sans-serif;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
  top: 0;
  position: absolute;
  width: 45vh;
  margin-top: 10px;
  transition: top 0.3s ease-in-out;
}

button {
  margin-top: 10px;
  padding: 5px 10px;
  cursor: pointer;
}

.header{
    font-weight:bold;
    font-size:20px;
    color:red;
}

.body{
    color:black;
    font-size:16px;
}

.footer{
    align-items: center;
    display: flex;
    justify-content: end;
    margin-top:20px;
}

.modal-button{
    margin-left:10px;
    margin-top: 10px;
    padding: 5px 17px;
    cursor: pointer;
    border-radius: 5px;
    font-family: 'Inter var', sans-serif;
    border:none;
}

.reject{
    background-color:green;
    color:white;
}

.accept{
    background-color:red;
    color:white
}

.form-container{
    display: flex;
    flex-direction: column;
    align-items: baseline;
}
.form-text{
    font-size:15px;
    font-weight:700;
    color:black;
    font-family: "Inter var", sans-serif;
}

.error-input {
    height:5vh;
    margin-bottom:5px;
    font-family: "Inter var", sans-serif;
    border-color:red;
}

.input-field{
    height:4vh;
    font-size:14px;
    font-family: "Inter var", sans-serif;
    :focus{
        border-color:white;
        box-shadow: 0 0 5px #f7951d;
    }
}

.text-error{
    font-family: "Inter var", sans-serif;
    color:red;
    font-size:10px;
    margin-left:2px;
    margin-bottom:0;
}
.text-errorfade{
    font-family: "Inter var", sans-serif;
    color:red;
    font-size:10px;
    margin-left:2px;
    opacity:0;
    margin-bottom:0;
}


@media only screen and (max-width: 425px){
    .modal-content {
        width:50%;
    }
    .header{
        font-size:16px;
    }

    .body{
        font-size:14px;
    }
    .footer{
        justify-content: space-between;
    }
    .modal-button{
        margin-left:0;
    }
}



`